module.exports = __webpack_public_path__ + "static/media/netaslogo.6b9c6ee7.png";